export enum TreeDialogMode {
  Edit,
  Create,
  CreateRoot,
}
